module.exports = __webpack_public_path__ + "img/3.a4616513.jpg";